import React from 'react';
import {
  SitrepCardSurface,
  type SitrepViewDataProps,
} from 'components/Reports/reports.types';
import { useInitDraftSitrepV2 } from 'components/DisasterGPT/hooks/useSitrepsV2';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import type { Incident } from 'components/IAP/hooks/incidentHooks';
import Loader from 'components/Loader/Loader';
import ReportsSitrepCard from 'components/Reports/ReportsSitrepCard';
import { buildDraftSitrepPayload } from 'components/Reports/utils/buildDraftSitrepPayload';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

type DraftReportViewProps = {
  draftSitreps: SitrepViewDataProps;
  scopeName: string;
  derivedAorId?: string | null;
  incident?: Incident;
};

const DraftReportView: React.FC<DraftReportViewProps> = ({
  draftSitreps,
  scopeName,
  derivedAorId,
  incident,
}) => {
  const initDraftMutation = useInitDraftSitrepV2();

  return (
    <div className="reports-tabs">
      {draftSitreps.isError ? (
        <div className="text-center mt-4">
          <span>Error loading reports.</span>
        </div>
      ) : !derivedAorId ? (
        <div className="text-center mt-4">
          <span>
            Unable to determine Area of Responsibility for this incident. Please
            ensure the incident is associated with an AOR in order to create and
            view draft SITREPs.
          </span>
        </div>
      ) : draftSitreps.isLoading ? (
        <Loader />
      ) : draftSitreps.data.length > 0 ? (
        draftSitreps.data.map((sitrep) => (
          <ReportsSitrepCard
            key={sitrep.id}
            sitrep={sitrep}
            surface={SitrepCardSurface.Draft}
          />
        ))
      ) : (
        <div className="reports-tabs__header__empty">
          <p>No Draft SITREPs found</p>
          <StylishNewButton
            className="button--primary"
            type="button"
            onClick={() => {
              initDraftMutation.mutate(
                buildDraftSitrepPayload({
                  scopeName,
                  aorId: derivedAorId,
                  incidentId: incident?.id,
                })
              );
            }}
            disabled={
              draftSitreps.isLoading || draftSitreps.isError || !derivedAorId
            }
          >
            <SharedIcon iconName="add" size="md" />
            Create Draft
          </StylishNewButton>
        </div>
      )}
    </div>
  );
};

export default DraftReportView;
